import { render, staticRenderFns } from "./CustomersNew.vue?vue&type=template&id=571cae7c&scoped=true"
import script from "./CustomersNew.vue?vue&type=script&lang=js"
export * from "./CustomersNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571cae7c",
  null
  
)

export default component.exports